import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

function EarningsCallTranscript({ transcript } :any) {
  return (
    <div>
      <style> {`
        /* Light theme. */
        :root {
          --color-canvas-default: #ffffff;
          --color-canvas-subtle: #f6f8fa;
          --color-border-default: #d0d7de;
          --color-border-muted: hsla(210, 18%, 87%, 1);
        }

        table {
          border-spacing: 0;
          border-collapse: collapse;
          display: block;
          margin-top: 0;
          margin-bottom: 16px;
          width: max-content;
          max-width: 100%;
          overflow: auto;
        }

        tr {
          background-color: var(--color-canvas-default);
          border-top: 1px solid var(--color-border-muted);
        }

        tr:nth-child(2n) {
          background-color: var(--color-canvas-subtle);
        }

        td,
        th {
          padding: 6px 13px;
          border: 1px solid var(--color-border-default);
        }

        th {
          font-weight: 600;
        }

        table img {
          background-color: transparent;
        }

        .dark-mode {
          --color-canvas-default: #222328;
          --color-canvas-subtle: #1a191d;
          --color-border-default: #322f2f;
          --color-border-muted: #322f2f;
        }

        .dark-mode th,
        .dark-mode td,
        .dark-mode .card-header p,
        .dark-mode strong {
          color: #ffffff;
        }

        .dark-mode .breadcrumb-item,
        .dark-mode .card-body p {
          color: #d8d8d8;
        }

        `}</style>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
          <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item"><a href="/earnings_calls">Earnings Calls</a></li>
            <li className="breadcrumb-item"><a href={ "/ticker/" + transcript?.ticker }>{transcript?.ticker}</a></li>
            <li className="breadcrumb-item"><a href={ "/earnings_call_list/" + transcript?.ticker }>{transcript?.ticker}'s earnings calls</a></li>
            <li className="breadcrumb-item"><a href={ "/earnings_call/" + transcript?.ticker + "?year=" + transcript?.year + "&quarter=" + transcript?.quarter }>{transcript?.ticker}'s Q{transcript?.quarter} {transcript?.year} Earnings Call Review with AI Assistant</a></li>
            <li className="breadcrumb-item active" aria-current="page">{transcript.ticker}'s Q{transcript.quarter} {transcript.year} earnings call transcript</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body col-lg-9 col-md-4">
              <div className="faq-section">
                <div className="container-fluid bg-gradient-success py-2">
                  <p className="mb-0 text-white">{transcript.company} ({transcript.ticker}) Earnings Call Transcript</p>
                </div>
                <div className="accordion">
                  <div className="card">
                    <div className="card-header" id="headingOne">
                      <h5 className="mb-0">
                        <p>{transcript.date}</p>
                      </h5>
                    </div>
                    <div id="collapseOne" className="collapse show">
                      <div className="card-body">
                        {transcript.content.map((item =>
                          <p>
                            <strong>{item.speaker}:</strong> <ReactMarkdown remarkPlugins={[remarkGfm]}>{item.message}</ReactMarkdown>
                          </p>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EarningsCallTranscript;
